// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.related-videos_wrapper__amy\\+Z {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: calc(100% - 72px);
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;

  z-index: 2; /* on small player, the pagination needs to be above the bottom bar */
}

.related-videos_grid__jP6eg {
  display: grid;
  grid-template-columns: repeat(auto-fit, var(--related-videos-card-width));
  grid-auto-rows: var(--related-videos-card-height);
  gap: var(--related-videos-gap);
  height: 100%;
  width: 100%;
  justify-content: center;
  align-content: center;
  overflow: hidden;

  padding: var(--related-videos-padding) var(--related-videos-padding) 0 var(--related-videos-padding);
}

.related-videos_card__dniAr {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  min-height: var(--related-videos-card-height);

  background: var(--backgroundColor);

  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);
  border-radius: 2px;

  transition: transform 0.2s;
  cursor: pointer;

  -webkit-text-decoration: none;

  text-decoration: none;
  outline: 0px solid var(--primaryColor);
  color: var(--textColor);

  animation: related-videos_slideUp__ZpxWL 0.5s ease 0s 1 normal forwards;
}

.related-videos_card__dniAr:hover,
  .related-videos_card__dniAr:focus-visible {
    transform: scale(1.05);
    outline: 2px solid var(--primaryColor);
  }

.related-videos_card__dniAr:hover .related-videos_playCircleIcon__ztytN, .related-videos_card__dniAr:focus-visible .related-videos_playCircleIcon__ztytN {
      opacity: 1;
    }

.related-videos_thumbnail__z1g0I,
.related-videos_thumbnail__z1g0I img {
  position: relative;
  width: 150px;
  max-width: 150px;
  aspect-ratio: 16 / 9;
  max-height: 84px;
  background-color: #000000;
}
.related-videos_playCircleIcon__ztytN {
  opacity: 0;
  transition: opacity 0.2s;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 32px;
  height: 32px;
}
.related-videos_playCircleIcon__ztytN svg {
    width: 100%;
    height: 100%;
  }
.related-videos_playCircleIcon__ztytN circle {
    fill: var(--primaryColor);
  }
.related-videos_playCircleIcon__ztytN path {
    fill: var(--overlayForeground);
  }

.related-videos_cardContent__iN2Kf {
  height: 100%;

  display: flex;
  gap: 10px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.related-videos_title__l-cn9 {
  color: var(--textColor);
  font-size: 16px;
  font-weight: 700;
  line-height: 25px;
  text-align: left;

  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.related-videos_pagination__8EKBC {
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
}

.related-videos_prevPageButton__mvi-P,
.related-videos_nextPageButton__eQ8k- {
  width: 24px;
  height: 24px;
  border: 0;
  padding: 0;
  border-radius: 2px;
  background-color: var(--backgroundColor);
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);
  cursor: pointer;

  transition: transform 0.2s;
}

.related-videos_prevPageButton__mvi-P:not(:disabled):hover,
    .related-videos_nextPageButton__eQ8k-:not(:disabled):hover,
    .related-videos_prevPageButton__mvi-P:not(:disabled):focus-visible,
    .related-videos_nextPageButton__eQ8k-:not(:disabled):focus-visible {
      outline: 2px solid var(--primaryColor);
      transform: scale(1.1);
    }

.related-videos_prevPageButton__mvi-P:disabled, .related-videos_nextPageButton__eQ8k-:disabled {
    cursor: default;
    opacity: 0.5;
  }

.related-videos_prevPageButton__mvi-P svg, .related-videos_nextPageButton__eQ8k- svg {
    width: 24px;
    height: 24px;
    padding: 6px;
    color: var(--textColor);
    fill: var(--textColor);
  }
.related-videos_prevPageButton__mvi-P svg {
  transform: rotate(180deg);
}

.related-videos_overlay__lrRJG {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--videoBackground);
  opacity: 0.33333;

  animation: related-videos_fadeIn__fE\\+tS 0.5s ease 0s 1 normal forwards;
}

.smallScreen .related-videos_wrapper__amy\\+Z {
    margin-bottom: -30px;
    gap: 5px;
  }

.smallScreen .related-videos_grid__jP6eg {
    grid-auto-rows: 1fr;
  }

.smallScreen .related-videos_card__dniAr {
    padding: 12px 20px;
    min-height: auto;
    height: 100%;
    min-width: auto;
    width: 100%;
  }

.smallScreen .related-videos_card__dniAr:hover,
    .smallScreen .related-videos_card__dniAr:focus-visible {
      transform: none;
    }

.smallScreen .related-videos_thumbnail__z1g0I,
  .smallScreen .related-videos_thumbnail__z1g0I img {
    width: 100%;
    max-width: 100px;
    max-height: 56px;
  }

.smallScreen .related-videos_prevPageButton__mvi-P:hover,
    .smallScreen .related-videos_nextPageButton__eQ8k-:hover,
    .smallScreen .related-videos_prevPageButton__mvi-P:focus-visible,
    .smallScreen .related-videos_nextPageButton__eQ8k-:focus-visible {
      transform: none;
    }

.smallScreen .related-videos_cardContent__iN2Kf {
    gap: 5px;
  }

.smallScreen .related-videos_title__l-cn9 {
    font-size: 12px;
    line-height: 14.63px;
  }

@media (prefers-reduced-motion) {
  .related-videos_card__dniAr {
    animation: none;
    transition: none;
  }
}

@keyframes related-videos_slideUp__ZpxWL {
  0% {
    opacity: 0;
    position: relative;
    top: 20px;
  }

  100% {
    opacity: 1;
    position: relative;
    top: 0;
  }
}

@keyframes related-videos_fadeIn__fE\\+tS {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0.33333;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/related-videos/related-videos.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mBAAmB;;EAEnB,UAAU,EAAE,qEAAqE;AACnF;;AAEA;EACE,aAAa;EACb,yEAAyE;EACzE,iDAAiD;EACjD,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;;EAEhB,oGAAoG;AACtG;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6CAA6C;;EAE7C,kCAAkC;;EAElC,+CAA+C;EAC/C,kBAAkB;;EAElB,0BAA0B;EAC1B,eAAe;;EAEf,6BAAqB;;EAArB,qBAAqB;EACrB,sCAAsC;EACtC,uBAAuB;;EAYvB,uEAAiD;AACnD;;AAXE;;IAEE,sBAAsB;IACtB,sCAAsC;EAKxC;;AAHE;MACE,UAAU;IACZ;;AAMJ;;EAEE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,wBAAwB;;EAExB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;AAcd;AAZE;IACE,WAAW;IACX,YAAY;EACd;AAEA;IACE,yBAAyB;EAC3B;AAEA;IACE,8BAA8B;EAChC;;AAGF;EACE,YAAY;;EAEZ,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;;EAEhB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,wCAAwC;EACxC,+CAA+C;EAC/C,eAAe;;EAEf,0BAA0B;AAsB5B;;AAnBI;;;;MAEE,sCAAsC;MACtC,qBAAqB;IACvB;;AAGF;IACE,eAAe;IACf,YAAY;EACd;;AAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;EACxB;AAEF;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;;EAEhB,uEAAgD;AAClD;;AAGE;IACE,oBAAoB;IACpB,QAAQ;EACV;;AAEA;IACE,mBAAmB;EACrB;;AAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;EAMb;;AAJE;;MAEE,eAAe;IACjB;;AAGF;;IAEE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;AAIE;;;;MAEE,eAAe;IACjB;;AAGF;IACE,QAAQ;EACV;;AAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;AAGF;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,MAAM;EACR;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  max-height: calc(100% - 72px);\n  height: 100%;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n\n  z-index: 2; /* on small player, the pagination needs to be above the bottom bar */\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, var(--related-videos-card-width));\n  grid-auto-rows: var(--related-videos-card-height);\n  gap: var(--related-videos-gap);\n  height: 100%;\n  width: 100%;\n  justify-content: center;\n  align-content: center;\n  overflow: hidden;\n\n  padding: var(--related-videos-padding) var(--related-videos-padding) 0 var(--related-videos-padding);\n}\n\n.card {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 20px;\n  min-height: var(--related-videos-card-height);\n\n  background: var(--backgroundColor);\n\n  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);\n  border-radius: 2px;\n\n  transition: transform 0.2s;\n  cursor: pointer;\n\n  text-decoration: none;\n  outline: 0px solid var(--primaryColor);\n  color: var(--textColor);\n\n  &:hover,\n  &:focus-visible {\n    transform: scale(1.05);\n    outline: 2px solid var(--primaryColor);\n\n    & .playCircleIcon {\n      opacity: 1;\n    }\n  }\n\n  animation: slideUp 0.5s ease 0s 1 normal forwards;\n}\n\n.thumbnail,\n.thumbnail img {\n  position: relative;\n  width: 150px;\n  max-width: 150px;\n  aspect-ratio: 16 / 9;\n  max-height: 84px;\n  background-color: #000000;\n}\n.playCircleIcon {\n  opacity: 0;\n  transition: opacity 0.2s;\n\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 32px;\n  height: 32px;\n\n  & svg {\n    width: 100%;\n    height: 100%;\n  }\n\n  & circle {\n    fill: var(--primaryColor);\n  }\n\n  & path {\n    fill: var(--overlayForeground);\n  }\n}\n\n.cardContent {\n  height: 100%;\n\n  display: flex;\n  gap: 10px;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.title {\n  color: var(--textColor);\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 25px;\n  text-align: left;\n\n  word-break: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.pagination {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  align-items: center;\n}\n\n.prevPageButton,\n.nextPageButton {\n  width: 24px;\n  height: 24px;\n  border: 0;\n  padding: 0;\n  border-radius: 2px;\n  background-color: var(--backgroundColor);\n  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n\n  transition: transform 0.2s;\n\n  &:not(:disabled) {\n    &:hover,\n    &:focus-visible {\n      outline: 2px solid var(--primaryColor);\n      transform: scale(1.1);\n    }\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.5;\n  }\n\n  & svg {\n    width: 24px;\n    height: 24px;\n    padding: 6px;\n    color: var(--textColor);\n    fill: var(--textColor);\n  }\n}\n.prevPageButton svg {\n  transform: rotate(180deg);\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--videoBackground);\n  opacity: 0.33333;\n\n  animation: fadeIn 0.5s ease 0s 1 normal forwards;\n}\n\n:global(.smallScreen) {\n  & .wrapper {\n    margin-bottom: -30px;\n    gap: 5px;\n  }\n\n  & .grid {\n    grid-auto-rows: 1fr;\n  }\n\n  & .card {\n    padding: 12px 20px;\n    min-height: auto;\n    height: 100%;\n    min-width: auto;\n    width: 100%;\n\n    &:hover,\n    &:focus-visible {\n      transform: none;\n    }\n  }\n\n  & .thumbnail,\n  & .thumbnail img {\n    width: 100%;\n    max-width: 100px;\n    max-height: 56px;\n  }\n\n  & .prevPageButton,\n  & .nextPageButton {\n    &:hover,\n    &:focus-visible {\n      transform: none;\n    }\n  }\n\n  & .cardContent {\n    gap: 5px;\n  }\n\n  & .title {\n    font-size: 12px;\n    line-height: 14.63px;\n  }\n}\n\n@media (prefers-reduced-motion) {\n  .card {\n    animation: none;\n    transition: none;\n  }\n}\n\n@keyframes slideUp {\n  0% {\n    opacity: 0;\n    position: relative;\n    top: 20px;\n  }\n\n  100% {\n    opacity: 1;\n    position: relative;\n    top: 0;\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0.33333;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `related-videos_wrapper__amy+Z`,
	"grid": `related-videos_grid__jP6eg`,
	"card": `related-videos_card__dniAr`,
	"slideUp": `related-videos_slideUp__ZpxWL`,
	"playCircleIcon": `related-videos_playCircleIcon__ztytN`,
	"thumbnail": `related-videos_thumbnail__z1g0I`,
	"cardContent": `related-videos_cardContent__iN2Kf`,
	"title": `related-videos_title__l-cn9`,
	"pagination": `related-videos_pagination__8EKBC`,
	"prevPageButton": `related-videos_prevPageButton__mvi-P`,
	"nextPageButton": `related-videos_nextPageButton__eQ8k-`,
	"overlay": `related-videos_overlay__lrRJG`,
	"fadeIn": `related-videos_fadeIn__fE+tS`
};
export default ___CSS_LOADER_EXPORT___;
